import { render, staticRenderFns } from "./AccountAddress.vue?vue&type=template&id=537df5c1&scoped=true&"
import script from "./AccountAddress.vue?vue&type=script&lang=js&"
export * from "./AccountAddress.vue?vue&type=script&lang=js&"
import style0 from "./AccountAddress.vue?vue&type=style&index=0&id=537df5c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537df5c1",
  null
  
)

export default component.exports